import ApexCharts from 'apexcharts'

window.renderPersonalityTypesChart = async (containerId, personalityTypes) => {
    const types = Object.keys(personalityTypes);
    const percecs = Object.values(personalityTypes);

    const minOpacity = .45;
    const maxOpacity = .9;

    var options = {
        title: {
            text: 'Distribuição (%) dos 9 tipos de personalidade',
            align: 'center',
            margin: 10,
            style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1e312a'
            },
        },
        chart: {
            animations: { enabled: false },
            type: 'bar',
            height: 550,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        series: [{ name: 'Similaridade', data: percecs }],
        plotOptions: {
            bar: { distributed: true },
        },
        colors: Array.from({ length: types.length }, function (_, i) {
            const a = (maxOpacity - minOpacity) / (types.length - 1);
            const b = minOpacity - a;
            return `rgba(0, 189, 119, ${(a * (types.length - i) + b).toFixed(2)})`;
        }),
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(1).replace(',', '').replace('.', ',') + "%";
            },
            style: {
                fontSize: '20px',
                fontWeight: 700,
                colors: ["#FFF"]
            }
        },
        xaxis: {
            categories: types.map(type => type.substring(1, 2)),
            axisTicks: { show: false },
            axisBorder: { show: false },
            labels: {
                style: {
                    fontSize: '20px',
                    fontWeight: 700,
                    colors: Array.from({ length: types.length }, () => '#ff8800'),
                },
                formatter: (value) => `Tipo ${value}`
            },
        },
        yaxis: {
            show: false,
            labels: { show: false }
        },
        grid: {
            show: false,
            padding: { top: 0, right: 0, bottom: 0, left: 0 },
        },
        legend: { show: false },
    }

    var chart = new ApexCharts(document.querySelector(`#${containerId}`), options)
    chart.updateOptions({ animate: false })
    await chart.render()
    return chart
}

window.renderPersonalityTriadsChart = async (containerId, personalityTriads) => {
    const triads = Object.keys(personalityTriads);
    const percecs = Object.values(personalityTriads);

    var options = {
        title: {
            text: 'Distribuição (%) entre os tipos das 3 tríades',
            align: 'center',
            margin: 10,
            style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1e312a'
            },
        },
        chart: {
            animations: { enabled: false },
            type: 'bar',
            height: 450,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        series: [{ name: 'Similaridade', data: percecs }],
        plotOptions: {
            bar: { distributed: true, horizontal: true },
        },
        colors: [
            'rgb(0, 81, 255)',
            'rgb(255, 196, 0)',
            'rgb(255, 0, 0)',
        ],
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return parseFloat(val).toFixed(1).replace(',', '').replace('.', ',') + "%";
            },
            style: {
                fontSize: '20px',
                fontWeight: 700,
                colors: ["#FFF"]
            }
        },
        legend: { show: false },
        xaxis: {
            categories: triads,
            axisTicks: { show: false },
            axisBorder: { show: false },
            labels: { show: false },
        },
        yaxis: {
            labels: {
                minWidth: 360,
                maxWidth: 360,
                style: {
                    fontSize: '20px',
                    fontWeight: 700,
                    colors: Array.from({ length: triads.length }, () => '#ff8800'),
                },
                formatter: function (val) {
                    if (isNaN(val)) return val;
                    return parseFloat(val).toFixed(1).replace(',', '').replace('.', ',') + "%";
                }
            }
        },
        grid: {
            show: false,
            padding: { top: 0, right: 0, bottom: 0, left: 20 },
        },
    }

    var chart = new ApexCharts(document.querySelector(`#${containerId}`), options)
    chart.updateOptions({ animate: false })
    await chart.render()
    return chart
}

window.renderPersonalitySubtypesChart = async (containerId, personalitySubtypes) => {
    const subtypes = Object.keys(personalitySubtypes);
    const percecs = Object.values(personalitySubtypes);

    const lengthByType = 3;
    const minOpacity = .45;
    const maxOpacity = .9;

    var options = {
        title: {
            text: 'Identificação dos subtipos mais prováveis de cada tipo',
            align: 'center',
            margin: 10,
            style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1e312a'
            },
        },
        chart: {
            animations: { enabled: false },
            type: 'bar',
            height: 750,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        series: [{ name: 'Similaridade', data: percecs }],
        plotOptions: {
            bar: { distributed: true, horizontal: true },
        },
        colors: [
            ...Array.from({ length: lengthByType }, function (_, i) {
                const a = (maxOpacity - minOpacity) / (lengthByType - 1);
                const b = minOpacity - a;
                return `rgba(0, 81, 255, ${(a * (lengthByType - i) + b).toFixed(2)})`;
            }),
            ...Array.from({ length: lengthByType }, function (_, i) {
                const a = (maxOpacity - minOpacity) / (lengthByType - 1);
                const b = minOpacity - a;
                return `rgba(255, 196, 0, ${(a * (lengthByType - i) + b).toFixed(2)})`;
            }),
            ...Array.from({ length: lengthByType }, function (_, i) {
                const a = (maxOpacity - minOpacity) / (lengthByType - 1);
                const b = minOpacity - a;
                return `rgba(255, 0, 0, ${(a * (lengthByType - i) + b).toFixed(2)})`;
            }),
        ],
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return parseFloat(val).toFixed(1).replace(',', '').replace('.', ',') + "%";
            },
            style: {
                fontSize: '20px',
                fontWeight: 700,
                colors: ["#FFF"]
            }
        },
        legend: { show: false },
        xaxis: {
            categories: subtypes,
            axisTicks: { show: false },
            axisBorder: { show: false },
            labels: { show: false },
        },
        yaxis: {
            labels: {
                minWidth: 360,
                maxWidth: 360,
                style: {
                    fontSize: '20px',
                    fontWeight: 700,
                    colors: Array.from({ length: subtypes.length }, () => '#ff8800'),
                },
                formatter: function (val) {
                    if (isNaN(val)) return val;
                    return parseFloat(val).toFixed(1).replace(',', '').replace('.', ',') + "%";
                }
            }
        },
        grid: {
            show: false,
            padding: { top: 0, right: 0, bottom: 0, left: 20 },
        },
    }

    var chart = new ApexCharts(document.querySelector(`#${containerId}`), options)
    chart.updateOptions({ animate: false })
    await chart.render()
    return chart
}

window.renderInstinctsChart = async (containerId, instincts) => {
    const instinctsNames = Object.keys(instincts);
    const percecs = Object.values(instincts);

    var options = {
        title: {
            text: 'Distribuição (%) dos instintos Autopreservação, Sexual e Social',
            align: 'center',
            margin: 10,
            style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#1e312a'
            },
        },
        chart: {
            animations: { enabled: false },
            type: 'pie',
            height: 600,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        series: percecs,
        labels: instinctsNames,
        colors: [
            'rgb(157, 1, 1)',
            'rgb(255, 109, 1)',
            'rgb(163, 22, 123)',
        ],
        legend: {
            position: 'bottom',
            fontSize: '20px',
            fontWeight: 700,
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return parseFloat(val).toFixed(1).replace(',', '').replace('.', ',') + "%";
            },
            style: {
                fontSize: '20px',
                fontWeight: 700,
                colors: ["#FFF"]
            }
        },
    }

    var chart = new ApexCharts(document.querySelector(`#${containerId}`), options)
    chart.updateOptions({ animate: false })
    await chart.render()
    return chart
}
